var _desc, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFocusTabella(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit-tabella") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#009846",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m10.318 3.3179c-3.7595 0.63536-6.7284 3.6043-7.3638 7.3638h1.5132c0.59442-2.9448 2.9058-5.2562 5.8506-5.8506zm3 0v1.5132c2.9448 0.59442 5.2562 2.9058 5.8506 5.8506h1.5132c-0.63535-3.7595-3.6043-6.7284-7.3638-7.3638zm-10.364 10.364c0.63535 3.7595 3.6043 6.7284 7.3638 7.3638v-1.5132c-2.9448-0.59442-5.2562-2.9058-5.8506-5.8506zm16.214 0c-0.59442 2.9448-2.9058 5.2562-5.8506 5.8506v1.5132c3.7595-0.63536 6.7284-3.6043 7.3638-7.3638z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    fill: "#fff",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusTabella);
export default __webpack_public_path__ + "static/media/focus-tabella.5416c09eaf6e55f6a6eaaf81c25bf04a.svg";
export { ForwardRef as ReactComponent };